import { useEffect } from 'react';

import type ErgAuthService from '@ergeon/erg-auth';

const SHARED_TOKEN_CHECK_INTERVAL_MS = 60 * 1000;

const useRefreshOnTokenChange = (authService: ErgAuthService, onRefresh: () => void) => {
  useEffect(() => {
    let knownToken = authService.getToken();

    const refreshWithCurrentToken = () => {
      knownToken = authService.getToken();
      onRefresh();
    };

    const tokenIsUnchanged = () => authService.getToken() === knownToken;

    const refreshIfTokenChanged = () => {
      if (tokenIsUnchanged()) {
        return;
      }

      refreshWithCurrentToken();
    };

    authService.on('refresh', refreshWithCurrentToken);
    document.addEventListener('visibilitychange', refreshIfTokenChanged);
    document.addEventListener('resume', refreshIfTokenChanged);
    const sharedTokenCheck = window.setInterval(refreshIfTokenChanged, SHARED_TOKEN_CHECK_INTERVAL_MS);

    return () => {
      authService.off('refresh', refreshWithCurrentToken);
      document.removeEventListener('visibilitychange', refreshIfTokenChanged);
      document.removeEventListener('resume', refreshIfTokenChanged);
      window.clearInterval(sharedTokenCheck);
    };
  }, [authService, onRefresh]);
};

export default useRefreshOnTokenChange;
